// extracted by mini-css-extract-plugin
export var fullHeightState = "_49-7";
export var headerCell = "_49-1";
export var loadingStateCell = "_49-4";
export var rowWrapper = "_49-3";
export var standaloneTable = "_49-8";
export var standaloneTableWithBodyFill = "_49-9";
export var stateCell = "_49-5";
export var table = "_49-0";
export var tableBodyFiller = "_49-6";
export var white = "_49-2";